import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { Col, Row } from "reactstrap"
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions"
import { useDispatch } from "react-redux"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useLocation } from "react-router-dom"

function AddEdit_CouponMaster() {
  const API_URL = API_WEB_URLS.MASTER + "/0/token/CouponMaster"
  const API_URL_SAVE = API_WEB_URLS.CouponMaster + "/0/token"
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/CouponMasterEdit/Id"

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  })

  const dispatch = useDispatch()
  const location = useLocation()

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0")

    const Id = (location.state && location.state.Id) || 0

    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    Discount: Yup.number()
      .required("Discount Percent is required")
      .min(0, "Discount Percent must be at least 0")
      .max(100, "Discount Percent cannot exceed 100"),
    ExpiryDate: Yup.date()
      .required("Expiry Date is required")
      .min(new Date(), "Expiry Date cannot be in the past"),
    CouponNo: Yup.string()
      .required("Coupon Number is required")
      .matches(/^\d+$/, "Coupon Number must be numeric"),
  })

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    let vformData = new FormData()

    vformData.append("Name", values.Name)
    vformData.append("Discount", values.Discount)
    vformData.append("ExpiryDate", values.ExpiryDate)
    vformData.append("CouponNo", values.CouponNo) // Add CouponNo to formData
    vformData.append("UserId", obj.uid)

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData: vformData } },
      API_URL_SAVE,
      true,
      "memberid"
    )
  }

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values)
        }}
      >
        {({ setFieldValue }) => (
          <Form className="form-horizontal">
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage
                  name="Name"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="Discount" className="form-label">
                  Discount Percent
                </label>
                <Field
                  className="form-control"
                  type="number"
                  name="Discount"
                />
                <ErrorMessage
                  name="Discount"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="ExpiryDate" className="form-label">
                  Expiry Date
                </label>
                <Field
                  className="form-control"
                  type="date"
                  name="ExpiryDate"
                />
                <ErrorMessage
                  name="ExpiryDate"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="CouponNo" className="form-label">
                  Coupon Number
                </label>
                <Field
                  className="form-control"
                  type="text"
                  name="CouponNo"
                />
                <ErrorMessage
                  name="CouponNo"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>
            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default AddEdit_CouponMaster
